// Footer.jsx
// Minimal footer: copyright text + optional links.
// Driven by siteConfig.footer.

import { Link } from "react-router-dom"

const Footer = ({ brand, links }) => {
	const year = new Date().getFullYear()

	return (
		<footer className="w-full border-t border-border bg-bg-surface">
			<div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between gap-4">
				<p className="text-xs text-text-disabled">
					© {year} {brand?.name ?? ""}. All rights reserved.
				</p>

				{links?.length > 0 && (
					<nav className="flex items-center gap-4">
						{links.map((link) => (
							<Link key={link.path} to={link.path} className="text-xs text-text-disabled hover:text-text-secondary transition-colors duration-quick">
								{link.label}
							</Link>
						))}
					</nav>
				)}
			</div>
		</footer>
	)
}

export default Footer
